import { useTranslation } from "react-i18next";
import styled from "styled-components";

const DateAdhésionContainer = styled.div`
    position : absolute;
    top : 20px;
    right : 20px;
    font-size : 12px;

    @media (max-width: 1000px) {
        top: 5px;
        right : 5px;
    }
`;

const DateAdhésion = (props) => {

    const { i18n } = useTranslation('common');

    if(!props.date) return null;

    const dateFormated = props.date.split('-').reverse().join('/');

    return (
        <DateAdhésionContainer>
            {i18n.language === "fr" ? "Date d'adhésion : " : "Membership date: "}{dateFormated}
        </DateAdhésionContainer>
    )
}

export default DateAdhésion;